let company = 'sunset';
// let ROOT_URL = `https://${company}-scm.truckxi.com/api/`;

/* companies using different branch
Lees multiWH-lee
norstat multiWH-norstar
*/

const generateBase = () => {
  const url = window.location.host;
  const base = url.substring(0, url.indexOf('-'));
  return base;
};

const generateRootUrl = () => {
  const base = generateBase();
  if (!base) return `https://${company}-scm.truckxi.com/api/`
  if (base === 'local') return 'http://localhost:8001/';
  return `https://${base}-scm.truckxi.com/api/`
};

let ROOT_URL = generateRootUrl();
// let ROOT_URL = 'http://localhost:8001/';
// falcon: https://scm.realtoreasier.com/;
// let ROOT_URL = 'https://scm.gvyummy.com/api/';
// let ROOT_URL = 'https://erp.chinatown-supermarket.com/api/';
// let ROOT_URL = 'https://hfstage-erp.trugckxi.com/api/';
let VERSION_NUM = '20018';
// daicheong, sunsun

const companyCode = localStorage.getItem('companyCode');
let ROOT_API_URL = '';
if (companyCode === 'PS') {
  ROOT_API_URL = 'https://premiumstella-scm.truckxi.com/api/';
} else if (companyCode === 'LAC') { // isCalco
  ROOT_API_URL = 'https://calco-scm.truckxi.com/api/';
} else if (companyCode === 'CW') {
  ROOT_API_URL = 'https://chunwei-scm.truckxi.com/api/';
} else if (companyCode === 'CT') { // isEcity
  ROOT_API_URL = 'https://ct-scm.truckxi.com/api/';
} else if (companyCode === 'MM') { // isMyuMyu
  ROOT_API_URL = 'https://myumyu-scm.truckxi.com/api/';
} else if (companyCode === 'JML') { // isJML
  ROOT_API_URL = 'https://jml-scm.truckxi.com/api/';
} else if (companyCode === 'HMM') { // isHMM
  ROOT_API_URL = 'https://fushon-scm.truckxi.com/api/';
  // ROOT_API_URL = 'https://hmm-scm.truckxi.com/api/';
} else if (companyCode === 'DHC') { // isDHC
  ROOT_API_URL = 'https://dhc-scm.truckxi.com/api/';
} else if (companyCode === 'AFG') { // isAFG
  ROOT_API_URL = 'https://afg-scm.truckxi.com/api/';
} else if (companyCode === 'RVR') { // isRivera
  ROOT_API_URL = 'https://rivera-scm.truckxi.com/api/';
} else if (companyCode === 'YB') { // isYibao
  ROOT_API_URL = 'https://yipao-scm.truckxi.com/api/';
} else if (companyCode === 'LK') { // isLucky
  ROOT_API_URL = 'https://lucky-scm.truckxi.com/api/';
} else if (companyCode === 'WE') { // isWecom
  ROOT_API_URL = 'https://wecom-scm.truckxi.com/api/';
} else if (companyCode === 'KH') { // isKouhigh
  ROOT_API_URL = 'https://afg-scm.truckxi.com/api/';
} else if (companyCode === 'FV') { // isFung
  ROOT_API_URL = 'https://fung-scm.truckxi.com/api/';
} else if (companyCode === 'CO') { // isCO
  ROOT_API_URL = 'https://co-scm.truckxi.com/api/';
} else if (companyCode === 'MMD') { // isMMD
  ROOT_API_URL = 'https://mmdavis-scm.truckxi.com/api/';
} else if (companyCode === 'SY') { // isSY
  ROOT_API_URL = 'https://sunny-scm.truckxi.com/api/';
} else if (companyCode === 'GV') { // isGV
  ROOT_API_URL = 'https://gvyummy-scm.truckxi.com/api/';
} else if (companyCode === 'FN') { // isFN
  ROOT_API_URL = 'https://falcon-scm.truckxi.com/api/';
} else if (companyCode === 'PTS') { // isPTS
  ROOT_API_URL = 'https://phantoscope-scm.truckxi.com/api/';
} else if (companyCode === 'AFM') { // isAFM
  ROOT_API_URL = 'https://afm-scm.truckxi.com/api/';
} else if (companyCode === 'AN') { // isAN
  ROOT_API_URL = 'https://asian-scm.truckxi.com/api/';
} else if (companyCode === 'ABC') { // isABC
  ROOT_API_URL = 'https://abc-scm.truckxi.com/api/';
} else if (companyCode === 'TN') { // isTN
  ROOT_API_URL = 'https://tn-scm.truckxi.com/api/';
} else if (companyCode === 'SV') { // isSV
  ROOT_API_URL = 'https://sunset-scm.truckxi.com/api/';
} else if (companyCode === 'PD') { // isPD
  ROOT_API_URL = 'https://uspride-scm.truckxi.com/api/';
} else if (companyCode === 'FC') { // isFC
  ROOT_API_URL = 'https://fit-scm.truckxi.com/api/';
} else if (companyCode === 'JTB') { // isJTB
  ROOT_API_URL = 'https://jtb-scm.truckxi.com/api/';
} else if (companyCode === 'IN') { // isIN
  ROOT_API_URL = 'https://inutra-scm.truckxi.com/api/';
} else if (companyCode === 'CNT') { // isCNT
  ROOT_API_URL = 'https://erp.chinatown-supermarket.com/api/';
} else if (companyCode === 'WIZ') { // isWIZ
  ROOT_API_URL = 'https://wiz-scm.truckxi.com/api/';
} else if (companyCode === 'DSQ') { // isDSQ
  ROOT_API_URL = 'https://dsq-scm.truckxi.com/api/';
} else if (companyCode === 'FJ') { // isFJ
  ROOT_API_URL = 'https://fj-scm.truckxi.com/api/';
} else if (companyCode === 'HF') { // isHF
  ROOT_API_URL = 'https://hfstage-erp.truckxi.com/api/';
} else if (companyCode === 'NBT') { // isNBT
  ROOT_API_URL = 'https://nbtstage-scm.truckxi.com/api/';
} else if (companyCode === 'MAG') { // isMAG
  ROOT_API_URL = 'https://magna-scm.truckxi.com/api/';
} else if (companyCode === 'TQ') { // isTQ
  ROOT_API_URL = 'https://tq-scm.truckxi.com/api/';
} else if (companyCode === 'FACEX') {
  ROOT_API_URL = 'https://facex-scm.truckxi.com/api/';
} else if (companyCode === 'OCM') { // isOCM
  ROOT_API_URL = 'https://ocm-scm.truckxi.com/api/';
} else if (companyCode === 'SH') { // isSH
  ROOT_API_URL = 'https://smilinghome-scm.truckxi.com/api/';
} else if (companyCode === 'LE') { // isLE
  ROOT_API_URL = 'https://lees-scm.truckxi.com/api/';
} else if (companyCode === 'EKC') { //is365
  ROOT_API_URL = 'https://365-scm.truckxi.com/api/';
} else if (companyCode === 'NS') { //norstar
  ROOT_API_URL = 'https://norstar-scm.truckxi.com/api/';
} else if (companyCode === 'WAK') {
  ROOT_API_URL = 'https://wakool-scm.truckxi.com/api/';
} else if (companyCode === 'OLG') {
  ROOT_API_URL = 'https://olong-scm.truckxi.com/api/';
} else if (companyCode === 'LMH') {
  ROOT_API_URL = 'https://lmh-scm.truckxi.com/api/';
} else if (companyCode === 'VAK') {
  ROOT_API_URL = 'https://vakker-scm.truckxi.com/api/';
} else if (companyCode === 'CTP') {
  ROOT_API_URL = 'https://ctp-scm.truckxi.com/api/';
} else {
  ROOT_API_URL = ROOT_URL;
}
let companyCodeTitle = companyCode ? companyCode + ' Truckxi-SCM' : 'Truckxi-SCM';
// let companyCodeTitle = 'VIP Truckxi-SCM';
if (ROOT_URL === 'https://scm.gvyummy.com/api/') {
  companyCodeTitle = companyCode + ' SCM';
}

const checkCompany = (companies = [], identifierCompanyCode) => {
  if (companyCode === identifierCompanyCode) {
    return true;
  }
  let currentCompany = generateBase();
  if (!currentCompany) {
    currentCompany = company
  }
  return companies.indexOf(generateBase() || company) >= 0;
}

export const isRebuild = companyCode === 'CRW' || companyCode === 'HM' ||
companyCode === 'JRC' || companyCode === 'LMH' || companyCode === 'VAK' ||
companyCode === 'OLG' || companyCode === 'SUN' || companyCode === 'AB' ||
companyCode === 'EKC' || companyCode === 'SH' || companyCode === 'SW' ||
companyCode === 'HMM' || companyCode === 'SV' || companyCode === 'OCM' ||
companyCode === 'MH' || companyCode === 'GFD' || companyCode === 'GGI' ||
companyCode === 'SKH' || companyCode === 'TU' || companyCode === 'HM' ||
companyCode === 'CCW' || companyCode === 'SC' ;

export const isABBLE = checkCompany(['abble'], 'AB');
export const isGGI = checkCompany(['ggi', 'ggistage'], 'GGI');
export const isOCM = checkCompany(['ocm', 'ocm2', 'ocmstage', 'nj'], 'OCM');
export const isDAICHEONG = checkCompany(['daicheong']);
export const isSH = checkCompany(['smilinghome']);
export const isLE = checkCompany(['lees']);
export const isHO = checkCompany(['horizon']);
export const isJRC = checkCompany(['jrc'], 'JRC');
export const isSV = checkCompany(['sunset']);
export const isEKC = checkCompany(['365'], 'EKC');
export const isLMH = checkCompany(['lmh', 'lmhstage'], 'LMH');
export const isLMHST = checkCompany(['lmhstage']);
export const isSDR = checkCompany(['shunde'], 'SDR');
export const isCRW = checkCompany(['craftwood'], 'CRW');
export const isESC = checkCompany(['esc']);
export const isSKH = checkCompany(['silkhome']);
export const isHMM = checkCompany(['fushon'], 'HMM');
export const isCPG = checkCompany(['cpg'], 'CPG');
export const isSUN = checkCompany(['sunsun']);
export const isARC = checkCompany(['arcadia']);
export const isNS = checkCompany(['norstar'], 'NS');
export const isWAK = checkCompany(['wakool'], 'WAK');
export const isOLG = checkCompany(['olong'], 'OLG');
export const isLAP = checkCompany(['lap'], 'LAP');
export const isGFD = checkCompany(['hkgf', 'hkgfstage'], 'GFD'); // hkgf
export const isVAK = checkCompany(['vakker', 'vakkercn'], 'VAK'); //vakker
export const isPRS = checkCompany(['pacific'], 'PRS'); //Pacific
export const isTU = checkCompany(['tustin', 'TU']) //Tustin
export const isABCFF = checkCompany(['abcff', 'ABCFF']); //ABCFF
export const isSW = checkCompany(['sunway', 'SW']);
export const isMH = checkCompany(['minhang'], 'MH'); //minhang
export const isTQ = checkCompany(['tq'], 'TQ');
export const isAGD = checkCompany(['angeldear'], 'AGD'); //angel dear
export const isKM = checkCompany(['kimi'], 'KM'); //kimi
export const isCTP = checkCompany(['ctp'], 'CTP'); //california truck parts
export const isVIP = checkCompany(['vipwholesale'], 'VIP'); //vipwholesale
export const isCCW = checkCompany(['ccw'], 'CCW'); // Chubby Cattle Wagyu
export const isSC = checkCompany(['squarecab'], 'SC'); // Square Cabinetry

/*
  These ROOT URLS were found on the url.jsx page.
  In case they're important later, I'll be leaving them here for safekeeping

  let ROOT_URL = "http://54.175.18.0/";
  let ROOT_URL = "http://oauth2.truckxi.com/";
  let ROOT_URL = "http://34.201.89.104/api/";
  let ROOT_URL = 'https://stage-scm.truckxi.com/api/'';
  let ROOT_URL = 'http://54.175.18.0/'';
  let ROOT_URL = 'http://192.168.0.13:8001/'';
*/

exports.VERSION_NUM = VERSION_NUM;
exports.ROOT_URL = ROOT_URL;
exports.ROOT_API_URL = ROOT_API_URL;
exports.companyCodeTitle = companyCodeTitle;



// WEBPACK FOOTER //
// ./master/jsx/actions/root_url.jsx